import clsx from 'clsx';
import { useMemo } from 'react';
import { format } from 'date-fns';

import { getLogIcon, getLogIconStyles, getLogInfo, getLogTitle } from './helpers';
import { ILogItemProps } from './types';
import { LogShipmentSummary } from './LogShipmentSummary';
import { LogShipments } from './LogShipments';

export const LogItem: React.FC<ILogItemProps> = (props) => {
  const { log } = props;

  const iconStyle = useMemo(() => getLogIconStyles(log), [log]);
  const itemIcon = useMemo(() => getLogIcon(log), [log]);
  const itemTitle = useMemo(() => getLogTitle(log), [log]);
  const itemContent = useMemo(() => getLogInfo(log), [log]);

  const summaries = useMemo(() => {
    const items = [];
    if (log?.invoiceStatusOverview && log.actionOnObject === 'PENDING_REVIEW') {
      for (const [label, number] of Object.entries(log.invoiceStatusOverview)) {
        if (number > 0) {
          items.push({
            shipmentTotal: number,
            workflowType: label,
            status: label,
          });
        }
      }
    }
    return items;
  }, [log]);

  return (
    <div className='pb-36 flex relative group gap-16'>
      <div className={clsx('w-36 h-36 rounded-5 flex items-center justify-center', iconStyle)}>{itemIcon}</div>
      <div className='flex-1'>
        <div className='flex gap-16'>
          <div className='flex-1 pt-6'>
            <h2 className='text-14 font-medium'>{itemTitle}</h2>
            <div className='text-14 text-blue_grey-30 capitalize'>{itemContent}</div>
          </div>
          <div className='pl-16 ml-auto w-[100px] text-12 leading-16 text-blue_grey-30 text-right'>
            {format(new Date(log?.createdOn), 'dd-MMM-yyyy hh.mm.aaaa')} SGT
          </div>
        </div>

        {summaries?.length > 0 && (
          <div className='mt-12'>
            <LogShipmentSummary items={summaries} />
          </div>
        )}

        {log?.shipmentLogs?.length > 0 && (
          <div className='mt-36'>
            <LogShipments shipmentLogs={log?.shipmentLogs} />
          </div>
        )}
      </div>
      <div className='group-last:hidden absolute left-18 top-[36px] bottom-0 w-1 bg-neutral-20' />
    </div>
  );
};
